import React, { useState } from "react";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	TextField,
	Stack
} from "@mui/material";
import { toast } from "react-toastify";
import toastError from "../../errors/toastError";
import { sendCtaUrl } from "../../services/wabaFeatures";

const EMPTY = { header: "", bodyText: "", footer: "", displayText: "", url: "" };

// Modal para enviar uma mensagem com BOTÃO DE LINK (CTA URL) pela API oficial.
// Só aparece em conexão WABA oficial + flag waba-cta-url (gate feito no chamador).
const WabaCtaModal = ({ open, onClose, whatsappId, to, ticketId }) => {
	const [form, setForm] = useState(EMPTY);
	const [loading, setLoading] = useState(false);

	const set = key => e => setForm(f => ({ ...f, [key]: e.target.value }));

	const handleClose = () => {
		if (loading) return;
		setForm(EMPTY);
		onClose();
	};

	const handleSend = async () => {
		if (!form.bodyText || !form.displayText || !form.url) {
			toast.error("Preencha a mensagem, o texto do botão e a URL.");
			return;
		}
		if (!/^https?:\/\//i.test(form.url)) {
			toast.error("A URL deve começar com http:// ou https://");
			return;
		}
		setLoading(true);
		try {
			await sendCtaUrl(whatsappId, { to, ticketId, ...form });
			toast.success("Mensagem com botão enviada!");
			setForm(EMPTY);
			onClose();
		} catch (err) {
			toastError(err);
		} finally {
			setLoading(false);
		}
	};

	return (
		<Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
			<DialogTitle>Enviar botão de link (WhatsApp oficial)</DialogTitle>
			<DialogContent>
				<Stack spacing={2} sx={{ mt: 1 }}>
					<TextField
						label="Cabeçalho (opcional)"
						value={form.header}
						onChange={set("header")}
						fullWidth
					/>
					<TextField
						label="Mensagem"
						value={form.bodyText}
						onChange={set("bodyText")}
						required
						multiline
						minRows={2}
						fullWidth
					/>
					<TextField
						label="Texto do botão"
						value={form.displayText}
						onChange={set("displayText")}
						required
						fullWidth
						inputProps={{ maxLength: 25 }}
						helperText="Máx. 25 caracteres"
					/>
					<TextField
						label="URL (https://...)"
						value={form.url}
						onChange={set("url")}
						required
						fullWidth
					/>
					<TextField
						label="Rodapé (opcional)"
						value={form.footer}
						onChange={set("footer")}
						fullWidth
					/>
				</Stack>
			</DialogContent>
			<DialogActions sx={{ p: 2, gap: 1 }}>
				<Button onClick={handleClose} disabled={loading}>
					Cancelar
				</Button>
				<Button onClick={handleSend} variant="contained" disabled={loading}>
					{loading ? "Enviando..." : "Enviar"}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default WabaCtaModal;
